<template>
  <div>
    <ul class="Fuell-Tabs">
      <li class="Fuell-Tabs--tab">
        <router-link
          to="/users/active"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{path: 'users_tab_section_active'}">
        </router-link>
      </li>
    </ul>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'UsersIndex'
}
</script>
